import { clsx } from "clsx";
import type { IconProps } from "./types";

export const CheckCircleOceanIcon = ({ className }: IconProps) => (
  <span
    className={clsx(
      "flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-ocean-500 text-white text-xl",
      className,
    )}
  >
    ✓
  </span>
);
